// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitListByType_role-list-by-type__eB8Ju {
  display: flex;
  flex-direction: column;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_unit-roles__-7bSA {
  display: flex;
  flex-direction: column;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_unit-roles__-7bSA .UnitListByType_title__4Ezrc {
  font-size: 18px;
  margin-bottom: 10px !important;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_unit-roles__-7bSA .UnitListByType_unit-role__XnHtS {
  cursor: pointer;
  border: 1px solid var(--unit-role);
  padding: 10px 20px;
  border-radius: 10px;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_unit-roles__-7bSA .UnitListByType_unit-role__XnHtS .UnitListByType_entity-title__cjSPa {
  color: var(--unit-role);
  font-weight: 500;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_personal-profile-roles__ud5lV {
  display: flex;
  flex-direction: column;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_personal-profile-roles__ud5lV .UnitListByType_title__4Ezrc {
  font-size: 18px;
  margin-bottom: 10px !important;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_personal-profile-roles__ud5lV .UnitListByType_personal-profile-role__Oaanh {
  border: 1px solid var(--personal-role);
  padding: 10px 20px;
  border-radius: 10px;
}
.UnitListByType_role-list-by-type__eB8Ju .UnitListByType_personal-profile-roles__ud5lV .UnitListByType_personal-profile-role__Oaanh .UnitListByType_entity-title__cjSPa {
  color: var(--personal-role);
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/UnitListManagement/Components/RoleListByType/UnitListByType.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;AAEJ;AADI;EACE,eAAA;EACA,8BAAA;AAGN;AADI;EACE,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;AAGN;AAFM;EACE,uBAAA;EACA,gBAAA;AAIR;AAAE;EACE,aAAA;EACA,sBAAA;AAEJ;AADI;EACE,eAAA;EACA,8BAAA;AAGN;AADI;EACE,sCAAA;EACA,kBAAA;EACA,mBAAA;AAGN;AAFM;EACE,2BAAA;EACA,gBAAA;AAIR","sourcesContent":[".role-list-by-type {\n  display: flex;\n  flex-direction: column;\n  .unit-roles {\n    display: flex;\n    flex-direction: column;\n    .title {\n      font-size: 18px;\n      margin-bottom: 10px !important;\n    }\n    .unit-role {\n      cursor: pointer;\n      border: 1px solid var(--unit-role);\n      padding: 10px 20px;\n      border-radius: 10px;\n      .entity-title {\n        color: var(--unit-role);\n        font-weight: 500;\n      }\n    }\n  }\n  .personal-profile-roles {\n    display: flex;\n    flex-direction: column;\n    .title {\n      font-size: 18px;\n      margin-bottom: 10px !important;\n    }\n    .personal-profile-role {\n      border: 1px solid var(--personal-role);\n      padding: 10px 20px;\n      border-radius: 10px;\n      .entity-title {\n        color: var(--personal-role);\n        font-weight: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"role-list-by-type": `UnitListByType_role-list-by-type__eB8Ju`,
	"unit-roles": `UnitListByType_unit-roles__-7bSA`,
	"title": `UnitListByType_title__4Ezrc`,
	"unit-role": `UnitListByType_unit-role__XnHtS`,
	"entity-title": `UnitListByType_entity-title__cjSPa`,
	"personal-profile-roles": `UnitListByType_personal-profile-roles__ud5lV`,
	"personal-profile-role": `UnitListByType_personal-profile-role__Oaanh`
};
export default ___CSS_LOADER_EXPORT___;
